module.exports = {
      id: "mail-usage",
      viewBox: "0 0 19 16",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#mail",
      toString: function () {
        return this.url;
      }
    }